<template>
 <div>
    We are sorry, but you do not have access. Please contact the Administrator for access.
 </div>
</template>

<script lang="ts" setup>

</script>
